import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { UserStore } from "@app/services/stores/UserStore";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { PaymentStore } from "@app/services/stores/PaymentStore";
import { PaymentEditStore } from "@app/services/stores/PaymentEditStore";
import { RegistrationStore } from "@app/pages/registration/stores/RegistrationStore";

@NgModule({
    imports: [BrowserModule],
    exports: [],
    declarations: [],
    providers: [
        HomeownerApi,
        UserStore,
        GuestPaymentStore,
        PaymentStore,
        PaymentEditStore,
        RegistrationStore,
    ]
})

export class StoresModule {}
